<template>
  <div class="v2-better-than-others">
    <h2 class="mb-3 mb-md-4">
      {{ t("Why Join the Ersties Community?") }}
    </h2>
    <div class="inner-container">
      <div class="row">
        <lazy-component class="col-md-6 d-none d-md-flex">
          <div class="cover w-100 rounded-1 ratio ratio-16x9" />
        </lazy-component>
        <div class="col-md-6 px-md-4 px-lg-6 py-md-4">
          <h3 class="text-center">
            {{ t("Enter our library of sex dreams") }}
          </h3>
          <lazy-component>
            <div class="cover w-100 d-md-none rounded-1 mb-3 ratio ratio-16x9" />
          </lazy-component>
          <p class="text-center">
            {{ t("Explore our deepest desires, get intimate with the models and enjoy 6 beautiful uploads a week. Celebrate sex with us!") }}
          </p>

          <div class="d-flex justify-content-center mt-4 mb-md-0 position-relative z-1">
            <button v-modal.modal-signup class="btn btn-primary border-dark" @click="sendRegistrationTrack">
              {{ t("Watch Real Pleasure") }}
            </button>
          </div>
        </div>
      </div>

      <span class="bg-sticker star-nude-large d-none d-md-inline-block">
        <img v-lazy="starNudeDarkSticker" :alt="`sticker star nude`" width="32" height="32" />
      </span>

      <span class="bg-sticker star-nude-small d-md-none">
        <img v-lazy="starNudeDarkSticker" :alt="`sticker star`" width="24" height="24" />
      </span>

      <span class="bg-sticker star-pink">
        <img v-lazy="starPinkDarkSticker" :alt="`sticker star pink`" width="24" height="24" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { useI18n } from "vue-i18n";
import starNudeDarkSticker from "@/assets/v2/images/stickers/star-nude-dark.svg";
import starPinkDarkSticker from "@/assets/v2/images/stickers/star-pink-dark.svg";

defineOptions({
  name: "better-than-others",
});

const { t } = useI18n();

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("Why Join the Ersties Community");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
